import { render, staticRenderFns } from "./SetTables.vue?vue&type=template&id=278913e4"
import script from "./SetTables.vue?vue&type=script&lang=js"
export * from "./SetTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports